import { useEffect } from 'react';
import type { NextPage } from 'next';
import Head from 'next/head';
import { MainLayout } from '../components/main-layout';
import { HomeHero } from '../components/home/home-hero';
import { gtm } from '../lib/gtm';

const Home: NextPage = () => {
  useEffect(() => {
    gtm.push({ event: 'page_view' });
  }, []);

  return (
    <>
      <Head>
        <title>Onderhoudsconfigurator</title>
      </Head>
      <main>
        <HomeHero />
      </main>
    </>
  );
};

Home.getLayout = (page) => (
  <MainLayout>
    {page}
  </MainLayout>
);

export default Home;
